const toCamelCase = str => {
    const camelCased = str.replace(/-([a-z])/g, function(g) {
        return g[1].toUpperCase()
    })
    return camelCased
}

const objectIsEmpty = obj => {
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false
    }
    return true
}

const splitDateTimeString = dtt => {
    dtt = dtt.split(' ')
    let date = dtt[0]
    let time = dtt[1].split('.')
    time = time[0]
    return { date, time }
}

export { toCamelCase, objectIsEmpty, splitDateTimeString }
